import React from 'react'
import ServiceItem from 'src/components/riders/rider-portal/trips/create/Step1/ServiceItem'
import Modal from 'src/components/riders/rider-portal/common/Modal'
import Divider from 'src/components/ui/Divider'
import Cross from 'src/components/icons/ui/Cross'
import { IService } from 'src/types'

interface IAllServicesModalProps {
  selectedService: IService | null
  services: IService[]
  modalTitle: string
  open: boolean
  handleClose: () => void
  handleSelectService: (service: IService) => void
}

const AllServicesModal = ({
  modalTitle,
  open,
  selectedService,
  services,
  handleClose,
  handleSelectService
}: IAllServicesModalProps) => (
  <Modal isOpen={open} width={768} onClose={handleClose}>
    <>
      <div className='flex items-center justify-between rp-p16'>
        <h3 className='font-black1 font-medium my0 rp-pr24 text-lg'>{modalTitle}</h3>
        <Cross className='icon--18x18 svg-color-black1' onClick={handleClose} />
      </div>
      <Divider />
      <div className='rp-p16 rp-modal-services-wrapper'>
        <div className='rp-services-wrapper'>
          {services.map(service => (
            <ServiceItem
              key={service.id}
              selectedService={selectedService}
              service={service}
              handleSelectService={handleSelectService}
            />
          ))}
        </div>
      </div>
    </>
  </Modal>
)

export default AllServicesModal



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/trips/create/Step1/AllServicesModal.tsx